/** Funciones de formato puras compartidas entre unit-maintenance-history y
 * maintenance-expense-history — evita duplicar los mismos 4 helpers en cada
 * componente. */

export function formatCurrency(value: number | null | undefined): string {
    if (value === null || value === undefined) return '—';
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value);
}

export function formatKm(value: number | null | undefined): string {
    if (value === null || value === undefined) return '—';
    return `${new Intl.NumberFormat('es-MX').format(value)} km`;
}

export function formatDate(value: string | null | undefined): string {
    if (!value) return '—';
    const [yyyy, mm, dd] = value.split('T')[0].split('-');
    return `${dd}/${mm}/${yyyy}`;
}

const MONTH_NAMES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

export function formatDateLong(value: string | null | undefined): string {
    if (!value) return '—';
    const [yyyy, mm, dd] = value.split('T')[0].split('-');
    return `${Number(dd)} ${MONTH_NAMES[Number(mm) - 1]} ${yyyy}`;
}
